/**
 * Named permissions a tenant admin can grant to a user on top of their role.
 * Admins hold all of them implicitly. Keys mirror the CHECK constraint on
 * public.user_permissions and map 1:1 onto the flags in useVisibility.
 */
export type Permission = 'company_financials' | 'profit' | 'tech_pay' | 'marketing_costs';

export const PERMISSIONS: { key: Permission; label: string; description: string }[] = [
  {
    key: 'company_financials',
    label: 'Company financials',
    description: 'Overall performance, Finance, Referrals and Reviews reports; company totals, KPIs and customer lifetime value; every CSR in the CSRs report.',
  },
  {
    key: 'profit',
    label: 'Profit',
    description: 'Profit on each job and each customer.',
  },
  {
    key: 'tech_pay',
    label: 'Technician pay',
    description: 'Commission rates and amounts; every technician in the Technicians report.',
  },
  {
    key: 'marketing_costs',
    label: 'Marketing costs',
    description: 'Advertising report, campaign spend, cost per lead and ROI.',
  },
];

export const ALL_PERMISSIONS: Permission[] = PERMISSIONS.map((p) => p.key);

export const isPermission = (v: string): v is Permission => (ALL_PERMISSIONS as string[]).includes(v);
